import React from 'react';
import { NavbarContainer } from './styles';

const Navbar: React.FC = ({ children }) => {
  return <NavbarContainer>{children}</NavbarContainer>;
};

export default Navbar;
